export default {
  // Left menu items
  menuItems: {
    details: {
      text: "Details",
      tooltip: "View details of nodes or transaction edges",
    },
    model: {
      text: "AI Model",
    },
    canvasfilter: {
      text: "Canvas Filter",
    },
    history: {
      text: "History",
    },
    suggestion: {
      text: "Survey Advice",
    },
  },
};
